module.exports = __webpack_public_path__ + "static/media/Marco.b3ddcff8.png";